import { faKey, faSignOut } from '@fortawesome/pro-solid-svg-icons';
import {
    ChangePassword,
    PasswordChanged,
    PasswordChangeFailed
} from './PasswordChange';
import { MenuItem, Header } from './Header';
import * as React from 'react';
import { User } from 'oidc-client';
import { oidcService as oidc, authService } from './Appstartup';

export interface HeaderContainerProps {
    appName: string;
    applications: any[];
    user: User | null;
}
export interface HeaderContainerState {
    notifications: any[];
    showMenu: boolean;
    showApps: boolean;
}
export class HeaderContainer extends React.Component<
    HeaderContainerProps,
    HeaderContainerState
> {
    constructor(props: HeaderContainerProps) {
        super(props);
        this.state = {
            notifications: [],
            showMenu: false,
            showApps: false
        };
    }
    private handleAccountIconClick = () => {
        this.setState({ showMenu: !this.state.showMenu });
    };
    private handleAppsIconClick = () => {
        this.setState({ showApps: !this.state.showApps });
    };
    private handleSignoutClick = () => {
        oidc.logout();
    };
    private handleChangePasswordClick = () => {
        let el = (
            <ChangePassword
                onCancel={this.clearNotifications}
                onSuccess={this.handleChangePasswordConfirm}
            />
        );
        this.setState({
            notifications: [el],
            showMenu: false
        });
    };
    private handleChangePasswordConfirm = async () => {
        let user = this.props.user;
        if (user === null) throw new Error('User cannot be null');
        let next = <PasswordChanged onComplete={this.clearNotifications} />;
        try {
            await authService.changePassword(user.profile.email);
        } catch {
            next = (
                <PasswordChangeFailed onComplete={this.clearNotifications} />
            );
        }
        this.setState({
            notifications: [next]
        });
    };
    private clearNotifications = () => {
        this.setState({ notifications: [] });
    };
    private getMenuItems() {
        return [
            <MenuItem
                key="1"
                onClick={this.handleChangePasswordClick}
                icon={faKey}
                text="Change password"
            />,
            <MenuItem
                key="2"
                onClick={this.handleSignoutClick}
                icon={faSignOut}
                text="Sign out"
            />
        ];
    }
    render() {
        return (
            <Header
                {...this.props}
                {...this.state}
                menuItems={this.getMenuItems()}
                onAccountIconClick={this.handleAccountIconClick}
                onAppsIconClick={this.handleAppsIconClick}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/HeaderContainer.tsx